module.exports = __webpack_public_path__ + "img/0_11.9520efdd.png";